"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Clock = void 0;
var three_1 = require("three");
var CSS3DRenderer_1 = require("three/examples/jsm/renderers/CSS3DRenderer");
var function_1 = require("../util/function");
var Clock = /** @class */ (function () {
    function Clock(base) {
        this.base = base;
        this.offset = 1.7;
        this.pos = new three_1.Vector3(-this.offset, 0, 0);
        this.normal = new three_1.Vector3(-1, 0, 0);
        this.cNormal = new three_1.Vector3();
        this.cPos = new three_1.Vector3();
        this.m4 = new three_1.Matrix4();
        this.setElement();
    }
    Clock.prototype.setElement = function () {
        this.element = this.base.domBundle.querySelector('#clock');
        this.object = new CSS3DRenderer_1.CSS3DObject(this.element);
        this.object.position.set(-this.offset, 0, 0);
        this.object.rotation.y = -Math.PI / 2;
        this.object.scale.set(1 / 160, 1 / 160, 1);
        this.initClock();
    };
    Clock.prototype.updateClock = function () {
        var now = new Date();
        var sec = now.getSeconds(), min = now.getMinutes(), hou = now.getHours(), mo = now.getMonth(), dy = now.getDate(), yr = now.getFullYear();
        var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        var tags = ["mon", "d", "y", "h", "m", "s"], corr = [months[mo], dy, yr, (0, function_1.pad)(hou, 2), (0, function_1.pad)(min, 2), (0, function_1.pad)(sec, 2)];
        for (var i = 0; i < tags.length; i++)
            this.element.querySelector("#".concat(tags[i])).innerHTML = corr[i].toString();
    };
    Clock.prototype.initClock = function () {
        this.updateClock(); //先執行一次避免開場有破綻
        this.timer = setInterval(this.updateClock.bind(this), 1000);
    };
    Clock.prototype.update = function () {
        (0, function_1.updateOcclude)(this);
    };
    return Clock;
}());
exports.Clock = Clock;
